"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const icon_module_scss_1 = __importDefault(require("./icon.module.scss"));
const baseUrl = "https://storage.googleapis.com/cgcdn/global-ui/icons";
const Icon = ({ children }) => react_1.default.createElement(react_1.default.Fragment, null, children);
const Solid = (_a) => {
    var { className = "", name } = _a, props = __rest(_a, ["className", "name"]);
    return (react_1.default.createElement(Icon, null,
        react_1.default.createElement("span", Object.assign({ className: (0, classnames_1.default)(icon_module_scss_1.default.solidIcon, className), "data-icon": name }, props))));
};
const Line = (_a) => {
    var { className = "", name } = _a, props = __rest(_a, ["className", "name"]);
    return (react_1.default.createElement(Icon, null,
        react_1.default.createElement("span", Object.assign({ className: (0, classnames_1.default)(icon_module_scss_1.default.lineIcon, className), "data-icon": name }, props))));
};
const Monochrome = (_a) => {
    var { className = "", name, emphasis = "gray" } = _a, props = __rest(_a, ["className", "name", "emphasis"]);
    const url = `${baseUrl}/${emphasis}/${name}.svg`;
    return (react_1.default.createElement(Icon, null,
        react_1.default.createElement("img", Object.assign({ className: (0, classnames_1.default)(icon_module_scss_1.default.monochromeIcon, className), src: url, alt: "Monochrome Icon" }, props))));
};
exports.default = { Icon, Solid, Line, Monochrome };
//# sourceMappingURL=icon.js.map